var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TopNavComponent } from './topnav.component';
import { SupportComponent } from './support.component';
import { NgModule } from '@angular/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MomentModule } from 'angular2-moment';
import { HttpClientModule, HttpClient } from '@angular/common/http';
export function httpFactory(http) {
    return new TranslateHttpLoader(http, '/assets/i18n/', '.json?t=' + process.env.VERSION);
}
var SharedModule = (function () {
    function SharedModule() {
    }
    SharedModule = __decorate([
        NgModule({
            imports: [
                HttpClientModule,
                TranslateModule.forRoot({
                    loader: {
                        provide: TranslateLoader,
                        useFactory: httpFactory,
                        deps: [HttpClient]
                    }
                }),
                BsDropdownModule.forRoot()
            ],
            declarations: [
                SupportComponent,
                TopNavComponent
            ],
            providers: [],
            exports: [
                SupportComponent,
                TopNavComponent,
                TranslateModule,
                BsDropdownModule,
                MomentModule
            ]
        })
    ], SharedModule);
    return SharedModule;
}());
export { SharedModule };
//# sourceMappingURL=shared.module.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared.module.js
// module id = 176
// module chunks = 0